import React , {useEffect} from "react";
import { Helmet } from "react-helmet";
import $ from "jquery";
import TypingEffect from './TypingEffect';

const Spelling = () => {

 
  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>React Spelling Page</title>
        <link rel="canonical" href="http://mysite.com/example" />
       
        <script>

 
        </script>
        

      </Helmet>
      {/* <div class="sform">
        <input type="text" id="auto" placeholder="" class="sfield" />
        <p id="outputcontent">
          <a class="cust-but">Click</a>
        </p>
      </div> */}
      <TypingEffect />
    </div>
  );
};

export default Spelling;
